export default "<nav>\n  <ld-user-menu></ld-user-menu>\n  <ld-language-switch></ld-language-switch>\n</nav>";